import { ServiceResponse } from 'loca-boot-core'
type Fetch = (...args: any[]) => Promise<ServiceResponse>

const cache: Record<string, any> = {}
const time: Record<string, number> = {}
const expire = 1000 * 60 * 10 // 10分钟

export const get = (key: string) => {
  const now = +new Date()
  if (now - time[key] > expire) {
    cache[key] = null
    delete cache[key]
  }
  return cache[key]
}

export const set = <T>(key: string, data: T) => {
  cache[key] = data
  time[key] = +new Date()
}

export function memoryCache<T extends Fetch>(fn: T): T {
  return <any>async function (...args: any[]) {
    const cacheKey = args
      .map((val) => {
        if (val instanceof Object) {
          return JSON.stringify(val)
        } else if (val instanceof Array) {
          return val.join('-')
        } else {
          return val
        }
      })
      .join(',')
    const cacheData = get(cacheKey)
    if (cacheData) {
      return cacheData
    }
    const data = await fn(...args)
    if (data.data && data.resultCode === 'success') {
      set(cacheKey, data)
    }
    return data
  }
}

export default {
  get,
  set,
}
